import { IFilter } from '@root/modules/Sellers/Product/interfaces';
import { formatDateTime } from '@root/utils/helpers/formatDate';
import { Col, Row, Table, Typography } from 'antd';
import React, { useEffect, useState } from 'react';
import mypage from '../services/mypage';
import { COLUMNS } from '@root/modules/Busk/Busk-Seller-Detail/components/IntergrationHistory';

const IntergrationHistory = () => {
  const [loading, setLoading] = useState(false);
  const [page, setPage] = useState(1);
  const [rows, setRows] = useState();
  const [totalRows, setTotalRows] = useState(0);

  const filter: IFilter = {};

  const getList = async () => {
    setLoading(true);

    const result = await mypage.getIntergrationHistory({
      page,
      limit: 10,
      filter
    });

    const data = result.data?.map((item: any) => {
      return {
        ...item,
        key: item.id,
        no: item.id,
        created_at: formatDateTime(item.created_at),
        disconnectDate: formatDateTime(item.disconnectDate)
      };
    });

    setRows(data);
    setTotalRows(result?.meta?.totalItems ?? 0);
    setLoading(false);
  };

  useEffect(() => {
    getList();
  }, []);

  useEffect(() => {
    const handleMessage = (event: MessageEvent) => {
      if (event.data.type === 'REFRESH_INTERGRATION_HISTORY') {
        getList();
      }
    };

    window.addEventListener('message', handleMessage);
    // Cleanup the event listener on component unmount
    return () => {
      window.removeEventListener('message', handleMessage);
    };
  }, []);

  useEffect(() => {
    getList();
  }, [page]);

  return (
    <div
      style={{
        borderRadius: 'var(--global-corner-md, 6px)',
        background: '#FFF',
        boxShadow: '0px 0px 32px 0px rgba(136, 152, 170, 0.15)'
      }}
    >
      <div className="busk-sellerSubHead">
        <Row align="middle">
          <Col flex="auto">
            <Typography.Text>연동 내역</Typography.Text>
          </Col>
        </Row>
      </div>
      <Table
        className="busk-table"
        pagination={{
          pageSize: 10,
          total: totalRows,
          onChange: (newPage) => {
            setPage(newPage);
          }
        }}
        loading={loading}
        columns={COLUMNS}
        dataSource={rows}
      />
    </div>
  );
};

export default IntergrationHistory;
